/* eslint-disable */
import { createStyles, makeStyles } from "@material-ui/core";
import type { Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: { 
      zIndex: theme.zIndex.drawer + 1,
      background: 'none',
    },
    paper: {
      width: '675px',
      background: '#E0E9F2',
      padding: theme.spacing(4, 7),
      boxShadow: '0 0 18px rgb(0 0 0 / 20%)',
    }
  })
);
